
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import ReisezieleDetail from '@/components/Reiseziele/ReisezieleDetail.vue';
    import Reiseziel from '@/types/Reiseziel';
    import { LoadReisezielePayload, ReisezieleFilter } from '@/store/reiseziele';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            ReisezieleDetail,
        },
        computed: {
            ...mapState('reiseziele', ['reiseziele', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('reiseziele', ['loadReiseziele', 'updateReiseziel']),
            ...mapMutations('reiseziele', ['setDialogsDetail']),
        },
    })
    export default class Reiseziele extends Vue {
        public loadReiseziele!: (payload?: LoadReisezielePayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public reiseziel = new Reiseziel();
        public search = '';

        public filter: ReisezieleFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Reiseziel> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Reiseziel', value: 'reiseziel' },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Impfempfehlung', value: 'impfempfehlung' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadReiseziele();
        }

        public onChangeFilter(): void {
            this.loadReiseziele({ filter: this.filter });
        }

        public onClickEdit(reiseziel: Reiseziel): void {
            this.reiseziel = new Reiseziel(reiseziel);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.reiseziel = new Reiseziel();
            this.setDialogsDetail(true);
        }
    }
